// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"SlideshowModal_modalContainer__aXvbZ","counterContainer":"SlideshowModal_counterContainer__FtSwZ"};